import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";

const removeHtmlRegex = /<[^>]*>/gi;
function sanitizeNoHtml(s) {
  return s.replace(removeHtmlRegex, " ");
}
function ProduktLink({ zeile }) {
  const text = (
    <span>
      {I18N("Art.Nr.")} {zeile.Artikelnummer}
    </span>
  );

  if (!zeile.Produktlink) {
    return text;
  }
  return (
    <a
      href={zeile.Produktlink.replaceAll("#", APP.settings.lang)}
      target="_blank"
      title={`${zeile.Artikelnummer} ${sanitizeNoHtml(zeile.ArtikeltextPreisuebersicht)}`}
      aria-label={I18N("aria::Produktdetails öffnen für Artikel") + " " + zeile.Artikelnummer}
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );
}

function StücklisteLabel({ bestellliste, gesamtpreis }) {
  return (
    <span
      data-info-key={
        bestellliste.map((x) => x.Artikelnummer).join(" + ") +
        " = " +
        I18N.formatCurrency(gesamtpreis)
      }
    >
      {bestellliste
        .map((Zeile, i) => Zeile.Artikelnummer && <ProduktLink key={i} zeile={Zeile} />)
        .reduce((a, b) => [a, <span key={a + b}>&nbsp;+&nbsp;</span>, b])}
      &nbsp;=&nbsp; {I18N.formatCurrency(gesamtpreis)}
    </span>
  );
}

export function ZaunCircleMenuItemInfo({}) {
  const agt = APP.arrangement;
  const contract = () => {
    const selected = agt.selectedObjects[0];
    return agt.selectedObjects.length == 1 && (selected?.isElement || selected?.isPfosten);
  };
  if (!contract()) {
    return null;
  }
  const selected = agt.selectedObjects[0];
  const bestellliste = selected.bestellliste ?? [];
  const gesamtpreis = selected.gesamtpreis;
  return (
    <ZaunCircleMenuItem dataButtonKey={I18N("aria::Elementinformationen")}>
      <div className="icon icon-info-circle" aria-hidden="true"></div>
      {bestellliste.length == 0 ? (
        <span>{selected.meta?.Key}</span>
      ) : (
        <StücklisteLabel {...{ bestellliste, gesamtpreis }} />
      )}
    </ZaunCircleMenuItem>
  );
}
